// extracted by mini-css-extract-plugin
export default {"wrapper":"ApartmentInformationLocation_wrapper__NqYwd","address":"ApartmentInformationLocation_address__2baUN"};